export enum TeamUserTypeEnum {
  ORG_MANAGER = "enterprise_manager",
  PENDING_SEAT = "pending_seat",
  ORG_SUPPORT = "enterprise_support",
  SELLER = "powur_energy",
  ORG_SELLER = "enterprise_consultant",
  ENT_OWNER = "powur_enterprise_pro",
  POWUR_PRO = "powur_enterprise",
  AMBASSADOR = "ambassador",
  POWUR_CLOSER = "powur_closer",
  ENTERPRISE_CLOSER = "enterprise_closer",
  POWUR_CLOSER_COMPED = "powur_closer_comped",
  POWUR_ENTERPRISE_PRO_COMPED = "powur_enterprise_pro_comped",
  POWUR_ENTERPRISE_PRO_CO_OWNER = "powur_enterprise_pro_co_owner",
  ENTERPRISE_CLOSER_COMPED = "enterprise_closer_comped",
  ENTERPRISE_MANAGER_COMPED = "enterprise_manager_comped",
  ENTERPRISE_SUPPORT_COMPED = "enterprise_support_comped",
  POWUR_ENERGY_COMPED = "powur_energy_comped",
  ENTERPRISE_CONSULTANT_COMPED = "enterprise_consultant_comped",
  POWURLINE_ENTERPRISE_MANAGER = "powurline_enterprise_manager",
  POWURLINE_ENTERPRISE_SUPPORT = "powurline_enterprise_support",
  POWURLINE_ENTERPRISE_CLOSER = "powurline_enterprise_closer",
  POWURLINE_ENTERPRISE_CONSULTANT = "powurline_enterprise_consultant",
}

export enum TeamTypeEnum {
  ORG_TEAM = "org_team",
  ORG_SEATED_TEAM = "org_team_seated",
  SELLER_TEAM = "seller_team",
}
